import { render } from "./LicenceWarning.vue?vue&type=template&id=5d15f236&scoped=true"
import script from "./LicenceWarning.vue?vue&type=script&lang=js"
export * from "./LicenceWarning.vue?vue&type=script&lang=js"

import "./LicenceWarning.vue?vue&type=style&index=0&id=5d15f236&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d15f236"]])

export default __exports__